import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch, faListCheck, faExclamationTriangle, faLifeRing, faUser, faEnvelope, faDatabase, faShieldAlt, faGlobe } from '@fortawesome/free-solid-svg-icons';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content help-modal">
        <div className="modal-header">
          <h2 className="modal-title"><FontAwesomeIcon icon={faLifeRing} className="modal-icon" /> Central de Ajuda - Checklist Espanha</h2>
          <button onClick={onClose} className="modal-close-btn" title="Fechar Ajuda">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-body help-content">
          <div className="help-section">
            <h3><FontAwesomeIcon icon={faSearch} /> Como Buscar um Cliente</h3>
            <p>Para encontrar um cliente e iniciar o processo de checklist:</p>
            <ol>
              <li>No campo <strong>"Email do cliente:"</strong>, digite o email completo do cliente.</li>
              <li>Certifique-se de que o email está correto para uma busca precisa.</li>
              <li>Clique no botão <strong>"Buscar"</strong>.</li>
              <li>Se o cliente for encontrado, seus dados aparecerão na tela. Se múltiplos clientes forem encontrados, um modal será exibido para que você selecione o cliente correto.</li>
              <li>Se o cliente não for encontrado, uma mensagem de erro será exibida.</li>
            </ol>
          </div>

          <div className="help-section">
            <h3><FontAwesomeIcon icon={faListCheck} /> Como Gerar um Checklist</h3>
            <p>Após selecionar um cliente, siga os passos para gerar o checklist:</p>
            <ol>
              <li>Selecione o <strong>"Tipo de Processo"</strong> desejado no dropdown.</li>
              <li>No campo <strong>"Nome do Cliente no App:"</strong>, insira o nome que aparecerá no documento.</li>
              <li>No campo <strong>"Atividade de Envio:"</strong>, descreva a atividade relacionada ao checklist.</li>
              <li>Clique em <strong>"Gerar Checklist"</strong>.</li>
              <li>O documento será baixado automaticamente.</li>
            </ol>
          </div>

          <div className="help-section">
            <h3><FontAwesomeIcon icon={faExclamationTriangle} /> Problemas Comuns</h3>
            <div className="troubleshooting">
              <div className="problem-item">
                <strong>Cliente não encontrado:</strong> Verifique se o email está correto e se o cliente está cadastrado no sistema.
              </div>
              <div className="problem-item">
                <strong>Documento não baixa:</strong> Verifique se o popup está bloqueado no navegador.
              </div>
            </div>
          </div>

          <div className="help-section">
            <h3><FontAwesomeIcon icon={faLifeRing} /> Suporte Técnico</h3>
            <p>Em caso de problemas técnicos, abra um ticket no GLPI para o time de tecnologia com as seguintes informações:</p>
            <ul>
              <li>Sistema: Checklist Espanha v2.0.0</li>
              <li>Descrição detalhada do problema</li>
              <li>Screenshot do erro (se houver)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
